// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRelatedContentLink_root__v6EBD"};